import React from "react"
import {FormattedMessage, injectIntl} from "react-intl";
import {Button} from "reactstrap";
import ContentUnitHeader from "../../content-unit-header";
import BaseComponent from "../../../base-component";
import {Fade} from "react-reveal";
import AttachmentsList from "../../attachments-list";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index";
import InnogyStyleIcon from "../../../innogy-style-icon";
import common_images from "../../../../common-images";
import i1_1 from './i1-1.svg';
import i1_2 from './i1-2.svg';
import i1_3 from './i1-3.svg';
import i1_4 from './i1-4.svg';
import i1_5 from './i1-5.svg';
import i1_6 from './i1-6.svg';
import i1_7 from './i1-7.svg';

class InnogyStyle extends BaseComponent {
    render() {
        const { assignment, readOnly } = this.props;
        const contentUnit = assignment.content_unit;
        const state = assignment.state;

        const headerData = {
            title: contentUnit.title,
            category: contentUnit.category,
            type: contentUnit.type,
        };

        const colClassBig = 'col-9 col-md-5 pb-5 mb-5';
        const colClassMiddle = 'col-3 col-md-2 mb-3 d-flex flex-column';
        const line = (<div className='bg-fiery-fuchsia-bright rounded m-auto flex-grow-1' style={{'width': '5px' }}/>);

        return (
            <div>
                <ContentUnitHeader contentUnit={headerData}/>
                <section className='pb-5'>
                    {
                        contentUnit.description && contentUnit.description.length > 0 &&
                        <div className='container mt-4 mb-4 text-center'>
                            {contentUnit.description}
                        </div>
                    }
                </section>
                <div className='container justify-content-center'>
                    <div className='text-center mb-5 pb-5 text-gray'>
                        <FontAwesomeIcon icon={['far', 'arrow-circle-down']}/><br/>
                        <p>Pro zobrazení sjeď níže</p>
                    </div>
                </div>
                <div className='container mt-5'>
                    <div className='row'>
                        <Fade left>
                            <div className={`${colClassMiddle} order-md-last`}>
                                <img width='220' height='220' src={i1_1} className='img-fluid mb-3' style={{height: 'fit-content'}}/>
                                { line }
                            </div>
                            <div className={`${colClassBig}`}>
                                <h2 className='text-turquoise'>1. Lidé, energie našeho úspěchu</h2>
                                <p>Základem úspěchu innogy i jejího každodenního fungování jsme my, její zaměstnanci. Naším cílem je vytvářet takové podmínky, aby nás práce bavila a aby se lidé uvnitř innogy k sobě chovali přátelsky a smáli se, mohli si plnit profesní a kariérní sny a současně žili naplno svůj osobní život.</p>
                            </div>
                        </Fade>
                    </div>
                    <div className='row justify-content-end'>
                        <Fade right>
                            <div className={colClassMiddle}>
                                <img width='220' height='220' src={i1_2} className='img-fluid mb-3' style={{height: 'fit-content'}}/>
                                { line }
                            </div>
                            <div className={`${colClassBig}`}>
                                <h2 className='text-turquoise'>2. Firemní hodnoty, vize a strategie</h2>
                                <p>V innogy vycházíme vstříc požadavkům moderního digitálního světa. Vytváříme udržitelný energetický systém pro budoucí generace a jsme úspěšní díky inovacím i tomu, že lidem nabízíme řešení nad rámec jejich běžných potřeb. Opíráme se o strategii „4P“ – pozice, performance (výkon), portfolio a partnerství. Naším cílem je dominovat trhu a být průkopníkem v oblasti inteligentních dodávek energie šetrné k životnímu prostředí.</p>
                            </div>
                        </Fade>
                    </div>
                    <div className='row'>
                        <Fade left>
                            <div className={`${colClassMiddle} order-md-last`}>
                                <img width='220' height='220' src={i1_3} className='img-fluid mb-3' style={{height: 'fit-content'}}/>
                                { line }
                            </div>
                            <div className={`${colClassBig}`}>
                                <h2 className='text-turquoise'>3. Osobní růst a diverzita</h2>
                                <p>Rozvíjíme sebe i lidi kolem nás. Společně. U nás v innogy má šanci uspět každý šikovný člověk bez ohledu na kulturu, pohlaví, věk, zdravotní strav, vyznání či sexuální orientaci. V innogy všestranně podporujeme osobní i profesní růst. Respektujeme druhé a také osobní život nás všech. Vedle prohlubování odborných znalostí se zaměřujeme především na manažerské dovednosti, znalost multikulturního prostředí a posilování leadershipu. Pomáháme zaměstnancům držet krok s aktuálními poznatky, trendy a technologiemi a podporujeme jejich profesní, kariérní i osobnostní růst.</p>
                            </div>
                        </Fade>
                    </div>
                    <div className='row justify-content-end'>
                        <Fade right>
                            <div className={colClassMiddle}>
                                <img width='220' height='220' src={i1_4} className='img-fluid mb-3' style={{height: 'fit-content'}}/>
                                { line }
                            </div>
                            <div className={`${colClassBig}`}>
                                <h2 className='text-turquoise'>4. Styl práce</h2>
                                <p>Nejnovější technologie, moderní způsoby komunikace, jedinečné projekty a zajímavá práce. To vše vytváří podmínky, které nám umožnují pracovat a myslet jinak. Podporujeme flexibilní formy práce, které nám umožňují pružně reagovat na naše pracovní povinnosti. Pomáhá nám i program NWoW (New Way of Working). Jeho principy vychází z inovativního stylu práce, otevřeného sdílení vědomostí a informací, moderního řešení pracovních postupů a efektivního řízení procesů i lidí.</p>
                            </div>
                        </Fade>
                    </div>
                    <div className='row'>
                        <Fade left>
                            <div className={`${colClassMiddle} order-md-last`}>
                                <img width='220' height='220' src={i1_5} className='img-fluid mb-3' style={{height: 'fit-content'}}/>
                                { line }
                            </div>
                            <div className={`${colClassBig}`}>
                                <h2 className='text-turquoise'>5. Pracovní prostředí a bezpečnost</h2>
                                <p>V zaměstnání strávíme více než půlku života. V innogy usilujeme o to, aby se nám všem pracovalo příjemně a pohodlně. Vytváříme prostředí, ve kterém můžeme využívat nejmodernější technologie a způsoby komunikace, kreativně tvořit a také si třeba zpříjemnit den výbornou kávou. Bezpečnost práce a zdraví je naší prioritou. Proto se s využitím různých programů snažíme naše zaměstnance v této oblasti vzdělávat a motivovat je k větší osobní angažovanosti.</p>
                            </div>
                        </Fade>
                    </div>
                    <div className='row justify-content-end'>
                        <Fade right>
                            <div className={colClassMiddle}>
                                <img width='220' height='220' src={i1_6} className='img-fluid mb-3' style={{height: 'fit-content'}}/>
                                { line }
                            </div>
                            <div className={`${colClassBig}`}>
                                <h2 className='text-turquoise'>6. Digitalizace</h2>
                                <p>Digitalizace je jedním z hlavních principů značky innogy. Abychom uspěli v moderním proměnlivém světě, vydali jsme se cestou digitalizace. Jejím prostřednictvím objevujeme nové možnosti využití digitálních technologií pro zefektivnění všech našich procesů a činností jak směrem k našim zákazníkům, kteří jsou u nás vždy na prvním místě, tak uvnitř naší firmy.</p>
                            </div>
                        </Fade>
                    </div>
                    <Fade left>
                        <div className='mt-3 mb-3 row justify-content-center'>
                            <div className='col-md-8'>
                                <img width='724' height='488' src={i1_7} className='img-fluid mb-3'/>
                            </div>
                        </div>
                    </Fade>
                    <AttachmentsList contentUnit={contentUnit}/>
                    {
                        !readOnly && state !== 'complete' &&
                        <div>
                            <hr/>
                            <Button onClick={this.props.markAsDone}><FormattedMessage id='app.actions.mark_as_done'/></Button>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default injectIntl(InnogyStyle);
